/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */

import { Reducer } from "redux";
import *as actionsTypesFromStore from '@apps-store/@types';
import { ReducersInterface } from '@apps-store/models';
import * as actions from '@apps-store/enums';

/**
 * @function LoginReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeLoginAction } action: action de l'application
 * @return { Reducer }
 */
export const LoginReducer: Reducer< ReducersInterface<any>> = ( state: any = {
   
} , action: actionsTypesFromStore.TypeLoginAction) => {
    
    switch (action.type) {

        case actions.LoginTypes.LOGIN_INPROGRESS:

            return {

                loading: true,
                ...state

            }
            
            break;
        case actions.LoginTypes.LOGIN_FAIL:

            return {

                error: action.payload.error ,
                loading: false,
                
            }
            
            break;
        
        case actions.LoginTypes.LOGIN_SUCCESS:

            return {

                data: action.payload.data ,
                loading: false,
                
            }
            
            break;
    
        default:
            return state
            break;
    }
    
}


// WEBPACK FOOTER //
// ./src/apps/store/reducers/login/index.ts